import axios from 'axios';
import VueCookies from 'vue-cookies';
import Vue from 'vue';

Vue.use(VueCookies);

let base;
if (process.env.NODE_ENV === 'development') {
  base = process.env.VUE_APP_DEV_URL;
} else if (process.env.NODE_ENV === 'staging') {
  base = process.env.VUE_APP_STAGING_URL;
} else {
  base = process.env.VUE_APP_PROD_URL;
}

// let head = {};

// process.env.VUE_APP_BASE_URL;

export const api = axios.create({
  baseURL: base,
  headers: {},
});

const postgresBase = process.env.VUE_APP_POSTGRES_DEV_URL;

export const postgresAPI = axios.create({
  baseURL: postgresBase,
  headers: {},
});
